// @ts-check
import { initSchema } from '@aws-amplify/datastore';
import { schema } from './schema';



const { DevFittrPageVisits, DevFittr3DScans, DevFittrOrganisations, DevFittrLocations, DevFittrLast, DevFittrModel, DevFittrOrder, DevFittrOSAOrder, DevFittrClosing, DevFittrStyle, DevFittrColor, DevFittrSpec, DevFittrHeight, DevFittrPriceLimit, DevModelCollection, FootcareWelt, FootcareApplicatie, FootcareOutsole, FootcareUpperleather, FootcareClosingItem, DevFittrOSAModel, DevFootcarePriceLevel, DevFootcareSupplier, DevFootcareHealthcareProvider, DevFittrOSAProperty, DevFittrOSAMaterial } = initSchema(schema);

export {
  DevFittrPageVisits,
  DevFittr3DScans,
  DevFittrOrganisations,
  DevFittrLocations,
  DevFittrLast,
  DevFittrModel,
  DevFittrOrder,
  DevFittrOSAOrder,
  DevFittrClosing,
  DevFittrStyle,
  DevFittrColor,
  DevFittrSpec,
  DevFittrHeight,
  DevFittrPriceLimit,
  DevModelCollection,
  FootcareWelt,
  FootcareApplicatie,
  FootcareOutsole,
  FootcareUpperleather,
  FootcareClosingItem,
  DevFittrOSAModel,
  DevFootcarePriceLevel,
  DevFootcareSupplier,
  DevFootcareHealthcareProvider,
  DevFittrOSAProperty,
  DevFittrOSAMaterial
};